var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.00244141,
    width: 26,
    height: 26,
    rx: 13,
    fill: "#8962D0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7034 16.8039L17.9387 17.1176C18.0362 17.2476 18.0098 17.4319 17.8799 17.5294C17.829 17.5676 17.7671 17.5882 17.7034 17.5882H8.29168C8.12924 17.5882 7.99756 17.4565 7.99756 17.2941C7.99756 17.2305 8.0182 17.1685 8.05638 17.1176L8.29168 16.8039V11.7059C8.29168 9.10689 10.3986 7 12.9975 7C15.5965 7 17.7034 9.10689 17.7034 11.7059V16.8039ZM11.527 18.1765H14.4681C14.4681 18.9886 13.8097 19.647 12.9975 19.647C12.1854 19.647 11.527 18.9886 11.527 18.1765Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.b606fb345705034c1c135b8c803edf1e.svg";
export { ForwardRef as ReactComponent };